import cx from 'clsx';
import React, { memo } from 'react';
import styles from '../HeaderSlot.module.scss';
import { isEqual } from 'src/utils/lodash-alternatives';
import { HeaderItem } from '../types';
import { createRel } from './utils';

interface ExternalItemProps {
  item: HeaderItem;
}

const ExternalItem: React.FC<ExternalItemProps> = memo(
  ({ item }) => (
    <a
      className={cx(
        styles.title,
        item.state === 'active' && styles.titleActive
      )}
      rel={createRel()}
      href={item.url || ''}
      target={item.target || ''}
    >
      {item.title}
    </a>
  ),
  (prevProps: ExternalItemProps, nextProps: ExternalItemProps) =>
    isEqual(prevProps, nextProps)
);

export default ExternalItem;
